export const SUBMIT = "SGI:EVENT_REPORT:SUBMIT";
